import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=e67227c4&scoped=true&"
import script from "./InputRadio.vue?vue&type=script&lang=js&"
export * from "./InputRadio.vue?vue&type=script&lang=js&"
import style0 from "./InputRadio.vue?vue&type=style&index=0&id=e67227c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67227c4",
  null
  
)

export default component.exports